
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"-2 -2 24 24","fill":"currentcolor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 14.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157a.999.999 0 01.29-.889l3.035-2.936-4.203-.612a.999.999 0 01-.752-.544L10 3.201 8.114 6.995a.999.999 0 01-.752.544l-4.203.612 3.036 2.936a.999.999 0 01.29.889l-.717 4.157 3.769-1.97c.145-.075.304-.113.463-.113zm5.562 4.905a.996.996 0 01-.463-.113l-5.1-2.664-5.098 2.664a1 1 0 01-1.448-1.057l.972-5.628-4.12-3.985a.998.998 0 01.55-1.708l5.702-.828L9.104.51c.338-.68 1.454-.68 1.792 0l2.546 5.126 5.701.828a.998.998 0 01.551 1.708l-4.12 3.985.973 5.628a1 1 0 01-.986 1.17z"}})])
          )
        }
      }
    